export const formatCurrency = (amount, isMask = true) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const value = parseFloat(amount);

  if (Number.isNaN(value)) {
    return null;
  }

  return formatter.format(isMask ? value / 100 : value);
};
